import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';

import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { findOptionsForSelectFilter } from '../../util/search';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '../../components';
import { EditListingOfferDescriptionForm } from '../../forms';
import config from '../../config';
import { types as sdkTypes } from '../../util/sdkLoader';
import { updateProfile } from '../../containers/ProfileSettingsPage//ProfileSettingsPage.duck';
import { turnCustomerIntoProviderMaybe } from '../../containers/EditListingPage/utils';
const { Money } = sdkTypes;
import { getDescriptionKeywords, getPostsKeywords } from '../../util/editListing';
import { isMobileSafari } from '../../util/userAgent';

import css from './EditListingOfferDescriptionPanel.module.css';

export class EditListingOfferDescriptionPanelComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: [],
      firstImageFromState: null,
    };
  }

  handleSetFirstImage = (file) => {
    if (file) {
      this.setState({ firstImageFromState: [file] })
    } else {
      this.setState({ firstImageFromState: null })
    }
  }

  handleSetInitialValues = (values) => {
    this.setState({ initialValues: values })
  }

  render() {

    const {
      className,
      rootClassName,
      listing,
      disabled,
      ready,
      onSubmit,
      onChange,
      submitButtonText,
      isNewListingFlow,
      panelUpdated,
      updateInProgress,
      errors,
      currentUser,
      hasProviderMarker,
      onUpdateProfile,
      onImageUpload,
      onLogoImageUpload,
      onRemoveImage,
      images,
      isDraftListing,
      onHandleValidatonPopup,
      onHandlePreviewPopup,
      onHandleCreateAndBublishListing,
      publishSuccess,
      onUpdateImageOrder,
      isProvider,
      currentUserListing,
    } = this.props;

    const isClient =
      currentUser?.attributes?.profile?.publicData?.userType === 'client' && !hasProviderMarker;
    const classes = classNames(rootClassName || css.root, className);
    const currentListing = ensureOwnListing(listing);
    const { description, title, price, publicData } = currentListing.attributes;

    const offerDescription = publicData?.offerDescription;

    const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
    const panelTitle = isPublished ? (
      <FormattedMessage
        id="EditListingOfferDescriptionPanel.title"
        values={{
          listingTitle: (
            <ListingLink listing={listing}>
              your offer
            </ListingLink>
          ),
        }}
      />
    ) : <FormattedMessage id="EditListingOfferDescriptionPanel.createTitle" />

    const { initialValues } = this.state;
    const isAdmin = currentUser?.attributes?.profile?.protectedData?.admin;
    const userWebsite = currentUser?.attributes?.profile?.publicData?.website;
    const ownListingDesc = currentUserListing?.attributes?.description;
    const {
      providerType,
      productType,
      category,
      companySize = [],
      operatingSince = [],
      paymentMethod,
      geographicalFocus,
    } = currentUserListing?.attributes?.publicData || {};

    const neededUserParams = {
      providerType,
      productType,
      category,
      companySize: companySize[0],
      operatingSince: operatingSince[0],
      paymentMethod,
      geographicalFocus,
    };

    return (
      <div className={classes}>
        <h1 className={css.title}>{panelTitle}</h1>
        <EditListingOfferDescriptionForm
          className={css.form}
          isAdmin={isAdmin}
          userWebsite={userWebsite}
          ownListingDesc={ownListingDesc}
          neededUserParams={neededUserParams}
          config={config}
          initialValues={{
            title: initialValues?.title || title,
            description: initialValues?.description || description,
            price: initialValues?.price || price,
            website: initialValues?.website || publicData?.website,
            shortDescription: initialValues?.shortDescription || publicData?.shortDescription,
            offerDescription: initialValues?.offerDescription || publicData?.offerDescription,
            images,
            files: initialValues?.files || ((!!publicData?.files?.length && [...publicData.files, undefined]) || [undefined]),
            videos: initialValues?.videos || publicData?.videos,
          }}
          saveActionMsg={submitButtonText}
          onSubmit={values => {
            const {
              title,
              website,
              shortDescription,
              description,
              offerDescription,
              files,
              videos,
            } = values;

            const trimmedTitle = title.trim();
            const keywords = uniq([
              ...getDescriptionKeywords(
                title,
                description,
                null,
                null,
                null,
                offerDescription,
                shortDescription,
              ),
              ...getPostsKeywords(
                get(publicData, 'news', []),
                get(publicData, 'content', []),
                get(publicData, 'events', [])
              ),
            ]);

            const filteredFiles = files?.filter(f => !!f);

            const updateValues = {
              title,
              description,
              publicData: {
                keywords,
                website,
                listingType: 'offer',
                isOffer: true,
                shortDescription,
                offerDescription,
                files: !!filteredFiles?.[0] ? filteredFiles.reverse() : null,
                videos: !!videos?.length && videos.reverse(),
              },
            };

            const firstImage = values.images.filter(
              img => typeof img.id === 'string' && img.id?.includes('backgroundPhoto-')
            );
            const newImages = values.images.filter(
              img => typeof img.id === 'string' && !img.id?.includes('backgroundPhoto-')
            );

            const savedImages = values.images.filter(img => !!img?.id?.uuid)

            updateValues.images = [...firstImage, ...savedImages, ...newImages];
            updateValues.publicData.backgroundPhotoIds = !!firstImage?.length &&
              (updateValues?.images?.[0]?.id?.uuid || updateValues?.images?.[0]?.imageId?.uuid) || publicData?.backgroundPhotoIds;

            return onSubmit(updateValues);

          }}
          onChange={onChange}
          disabled={disabled}
          ready={ready}
          updated={panelUpdated}
          updateInProgress={updateInProgress}
          fetchErrors={errors}
          isClient={isClient}
          isNewListingFlow={isNewListingFlow}
          isDraftListing={isDraftListing}
          currentUser={currentUser}
          onLogoImageUpload={onLogoImageUpload}
          publicData={publicData}
          imageUploadRequested={this.state.imageUploadRequested}
          onImageUploadHandler={this.onImageUploadHandler}
          onImageUpload={onImageUpload}
          onRemoveImage={onRemoveImage}
          handleSubmitFile={this.handleSubmitFile}
          images={images}
          onHandleValidatonPopup={onHandleValidatonPopup}
          onHandlePreviewPopup={onHandlePreviewPopup}
          onHandleCreateAndBublishListing={onHandleCreateAndBublishListing}
          listing={listing}
          publishSuccess={publishSuccess}
          onUpdateImageOrder={onUpdateImageOrder}
          handleSetFirstImage={this.handleSetFirstImage}
          firstImageFromState={this.state.firstImageFromState}
          isProvider={isProvider}
          handleSetInitialValues={this.handleSetInitialValues}
          description={description}
          offerDescription={offerDescription}
        />
      </div>
    );
  }
}

EditListingOfferDescriptionPanelComponent.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingOfferDescriptionPanelComponent.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const EditListingOfferDescriptionPanel = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EditListingOfferDescriptionPanelComponent);

export default EditListingOfferDescriptionPanel;
